"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalNavService = useGlobalNavService;
var react_1 = require("react");
var index_1 = require("./index");
function useGlobalNavService(options) {
    var _a = (0, react_1.useState)([]), apps = _a[0], setApps = _a[1];
    var _b = (0, react_1.useState)(false), hasError = _b[0], setError = _b[1];
    (0, react_1.useEffect)(function () {
        var service = new index_1.GlobalNavServiceV2(options === null || options === void 0 ? void 0 : options.isStudent);
        service
            .getList()
            .then(function (appsData) {
            setApps(appsData);
        })
            .catch(function () {
            setError(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { hasError: hasError, data: apps };
}
